// Single source of truth for the shipped content-pack version.
// Imported by both the Node harness (loadContent.ts) and the browser app.
export const CONTENT_VERSION = "m4.1.0-p0";
